import React, { useEffect } from "react";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import "./App.css";
import About from "./Components/about";
import Header from "./Components/header";
import Home from "./Components/home";
import Photos from "./Components/photos";
import Dashboard from "./Components/dashboard";
import { routeMetadata } from "./lib/routeMetadata";
import { resolveView } from "./lib/view";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.navigator.userAgent.includes("jsdom")) return;
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function currentView() {
  if (typeof window === "undefined") return "site";
  return resolveView({
    hostname: window.location.hostname,
    pathname: window.location.pathname,
  });
}

function RouteMetadata({ view }) {
  const { pathname } = useLocation();

  useEffect(() => {
    let metadata;
    if (view === "photos") metadata = routeMetadata.photos;
    else if (view === "dashboard") metadata = routeMetadata.dashboard;
    else metadata = routeMetadata[pathname.replace(/\/$/, "") || "/"] || routeMetadata["/"];

    document.title = metadata.title;

    const updateMeta = (selector, value) => {
      const element = document.head.querySelector(selector);
      if (element) element.setAttribute("content", value);
    };
    updateMeta('meta[name="description"]', metadata.description);
    updateMeta('meta[property="og:title"]', metadata.title);
    updateMeta('meta[property="og:description"]', metadata.description);
    updateMeta('meta[property="og:url"]', metadata.url);
    updateMeta('meta[name="twitter:title"]', metadata.title);
    updateMeta('meta[name="twitter:description"]', metadata.description);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", metadata.url);

    let robots = document.head.querySelector('meta[name="robots"]');
    if (view === "dashboard") {
      if (!robots) {
        robots = document.createElement("meta");
        robots.setAttribute("name", "robots");
        document.head.appendChild(robots);
      }
      robots.setAttribute("content", "noindex, nofollow");
    } else if (robots) {
      robots.setAttribute("content", "index, follow");
    }
  }, [pathname, view]);

  return null;
}

function App({ RouterComponent = Router, routerProps = {}, initialView } = {}) {
  const view = initialView || currentView();

  return (
    <RouterComponent {...routerProps}>
      <ScrollToTop />
      <RouteMetadata view={view} />
      <div className={view === "site" ? "app-container" : "app-container app-container--bare"}>
        {view === "site" && <Header />}
        {view === "dashboard" ? (
          <Routes>
            <Route path="*" element={<Dashboard />} />
          </Routes>
        ) : view === "photos" ? (
          <Routes>
            <Route path="*" element={<Photos />} />
          </Routes>
        ) : (
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/photos" element={<Photos />} />
          </Routes>
        )}
      </div>
    </RouterComponent>
  );
}

export default App;
